import { render, staticRenderFns } from "./BankVerify.vue?vue&type=template&id=4511b0e6&"
import script from "./BankVerify.vue?vue&type=script&lang=js&"
export * from "./BankVerify.vue?vue&type=script&lang=js&"
import style0 from "./BankVerify.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
